import cx from 'classnames';
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { MOCK_ACCESSORIES_STEP_COOKIE } from '|/app/services';
import { SLATE_THEME_OVERRIDE_COOKIE } from '|/context/slate-context';
import styles from './control-panel.module.css';

const SlateOverrides = () => {
  const [showInterface, setShowInterface] = useState(false);
  const [isThemeOverrideEnabled, setIsThemeOverrideEnabled] = useState(
    () => Cookies.get(SLATE_THEME_OVERRIDE_COOKIE) === 'true'
  );
  const [isAccessoriesMockEnabled, setIsAccessoriesMockEnabled] = useState(
    () => Cookies.get(MOCK_ACCESSORIES_STEP_COOKIE) === 'true'
  );

  if (process.env.NODE_ENV === 'production') return null;

  const hasAnyOverride = isThemeOverrideEnabled || isAccessoriesMockEnabled;

  const handleThemeChange = (enabled: boolean) => {
    setIsThemeOverrideEnabled(enabled);
    if (enabled) {
      Cookies.set(SLATE_THEME_OVERRIDE_COOKIE, 'true');
    } else {
      Cookies.remove(SLATE_THEME_OVERRIDE_COOKIE);
    }
    window.location.reload();
  };

  const handleAccessoriesMockChange = (enabled: boolean) => {
    setIsAccessoriesMockEnabled(enabled);
    if (enabled) {
      Cookies.set(MOCK_ACCESSORIES_STEP_COOKIE, 'true');
    } else {
      Cookies.remove(MOCK_ACCESSORIES_STEP_COOKIE);
    }
    window.location.reload();
  };

  return (
    <div className={styles.wrapper}>
      <button
        className={cx(styles.tab, showInterface && styles.expanded)}
        onClick={() => {
          setShowInterface(current => !current);
        }}
        data-analytics-id="pp_devpanel_slate_header"
      >
        {hasAnyOverride && <span className={styles.tabIndicatorDot} />}
        Slate
      </button>
      {showInterface && (
        <div className={styles.content}>
          <div className={styles.groupLabel}>Theme</div>
          <label htmlFor="slate-theme-vehicle-default" className={styles.radio}>
            <input
              type="radio"
              name="slate-theme-override"
              id="slate-theme-vehicle-default"
              checked={!isThemeOverrideEnabled}
              onChange={() => {
                handleThemeChange(false);
              }}
              data-analytics-id="pp_devpanel_slate_theme_default"
            />
            <div>vehicle default</div>
          </label>
          <label htmlFor="slate-theme-force-slate" className={styles.radio}>
            <input
              type="radio"
              name="slate-theme-override"
              id="slate-theme-force-slate"
              checked={isThemeOverrideEnabled}
              onChange={() => {
                handleThemeChange(true);
              }}
              data-analytics-id="pp_devpanel_slate_theme_force"
            />
            <div>force slate</div>
          </label>

          <div className={styles.groupLabel}>Accessories step</div>
          <label htmlFor="ppcp-mock-accessories-step" className={styles.checkbox}>
            <input
              type="checkbox"
              id="ppcp-mock-accessories-step"
              checked={isAccessoriesMockEnabled}
              onChange={e => {
                handleAccessoriesMockChange(e.target.checked);
              }}
              data-analytics-id="pp_devpanel_mock_accessories_toggle"
            />
            Insert mock step after Trade-in
          </label>
        </div>
      )}
    </div>
  );
};

export default SlateOverrides;
